export default __webpack_public_path__ + "8f22b294629293d29895fddef0a8baea.svg";